import { styled } from '@mui/material';

export const CardList = styled('div')(() => ({
  display: 'grid',
  gridTemplateColumns: 'repeat(auto-fit, minmax(330px, 1fr))',
  gap: '2rem',
}));
